import styled from '@emotion/styled'
import React from 'react'

const Wrapper = styled.div`
  padding: 0;
  svg {
    stroke: #3ec7b3;
    fill: #3ec7b3;
  }
`

/**
 * SVGアイコンコンポーネント
 * ロゴ
 */
const SearchSvg = (): JSX.Element => (
  <Wrapper className="svg-icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g transform="translate(5 3)" fill="none" strokeWidth="2">
        <circle cx="12" cy="12" r="12" stroke="none" />
        <circle cx="12" cy="12" r="11" fill="none" />
      </g>
      <rect
        width="4"
        height="14"
        rx="2"
        transform="translate(20.768 25.526) rotate(-30)"
      />
    </svg>
  </Wrapper>
)
export default SearchSvg
